import ServicePage from "@/components/ServicePage";

export default function VehicleRecovery() {
  return (
    <ServicePage
      slug="vehicle-recovery"
      testid="page-vehicle-recovery"
      title="Vehicle Recovery UK | 24/7 Breakdown & Accident Recovery | MHJ Prestige Transport"
      metaDescription="24/7 vehicle recovery across the UK — breakdowns, accident recovery and post-fault collection. Fast dispatch, fully insured. Get an instant recovery quote online."
      h1="24/7 vehicle recovery, wherever you are"
      intro="Broken down, been in an accident, or car won't start? We're on the road 24 hours a day for breakdown recovery, accident recovery and secure onward transport."
      heroImage="https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/3n3iv3ni_Screenshot_20260609_112234_Gallery.jpg"
      bullets={[
        "24/7 dispatch — day, night, weekends and bank holidays",
        "Roadside, motorway and off-road recovery covered",
        "Accident recovery with insurance-friendly documentation",
        "Immediate collection or scheduled recovery — you choose",
        "Fully insured, DVSA-compliant transporters",
        "Instant online recovery quote — no waiting on hold",
      ]}
      sections={[
        {
          title: "When to call for recovery",
          body: (
            <p>
              If your car is unsafe to drive, out of fuel, has been in a collision, or has stopped
              somewhere it shouldn&rsquo;t be — we&rsquo;ll come to you. For roadside emergencies always
              call us directly; for planned recoveries the online quote is the fastest route.
            </p>
          ),
        },
        {
          title: "Accident recovery",
          body: (
            <p>
              Non-fault accident? We&rsquo;ll recover your vehicle to a body shop, your home or an
              approved storage facility, and provide the paperwork your insurer or claims management
              company will need. If the vehicle is a total loss we can move it to salvage or auction
              instead.
            </p>
          ),
        },
      ]}
      faq={[
        {
          q: "Are you a 24/7 recovery service?",
          a: "Yes — MHJ dispatches recovery vehicles 24 hours a day, 365 days a year.",
        },
        {
          q: "Do you recover from motorways?",
          a: "Yes, we operate on all UK motorways subject to National Highways clearance protocols.",
        },
        {
          q: "Can you handle a total-loss vehicle?",
          a: "Yes. We recover write-offs to salvage yards, auction sites or safe storage as required.",
        },
        {
          q: "How quickly can you reach me?",
          a: "It depends on your location and the current traffic conditions — call us and we'll give you a live ETA.",
        },
      ]}
    />
  );
}
